import { Input } from "@comcord/ui/input";

export function Search() {
  return (
    <button>
      <Input
        type="search"
        placeholder="Search..."
        className={"transform-all  h-9 w-20 duration-700 focus:w-48"}
      />
    </button>
  );
}
